// extracted by mini-css-extract-plugin
export default {"skip_main_content":"BasicLayout_skip_main_content__N7C9d"};